/** Sidebar destinations — show the page title, not a Back button. */
export const PORTAL_TOP_LEVEL_PATHS = new Set([
  '/dashboard',
  '/requests',
  '/posts',
  '/users',
  '/vetted-users',
  '/events',
  '/aria-handsoff',
  '/admin-management',
  '/partner-management',
  '/feedback',
  '/subscriptions',
  '/notifications',
  '/partner-dashboard',
  '/partner-events',
  '/partner-community',
  '/partner-aria-handsoff',
  '/partner-analytics',
  '/partner-subscription',
  '/partner-settings',
  '/partner-notifications',
  '/partner-attendees',
]);

export const isPortalTopLevelPath = (pathname) => PORTAL_TOP_LEVEL_PATHS.has(pathname);
